import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { KnowledgeBaseStats } from '../types';

interface KnowledgeBaseMetricsProps {
  stats: KnowledgeBaseStats | null;
}

export const KnowledgeBaseMetrics: React.FC<KnowledgeBaseMetricsProps> = ({ stats }) => {
  const { t } = useTranslation();
  if (!stats) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map(i => (
          <MetricCard key={i} title={t('common.loading')} value="" loading={true} />
        ))}
      </div>
    );
  }

  const metricCards = [
    {
      title: t('knowledgeBase.totalDocuments'),
      value: stats.total_documents,
      icon: 'description',
      variant: 'primary' as const,
      trend: t('knowledgeBase.allUploadedDocuments'),
      trendType: 'neutral' as const,
    },
    {
      title: t('knowledgeBase.knowledgeBases'),
      value: stats.knowledge_bases,
      icon: 'folder',
      variant: 'success' as const,
      trend: t('knowledgeBase.availableKnowledgeBases'),
      trendType: 'positive' as const,
    },
    {
      title: t('knowledgeBase.processingStatus'),
      value: stats.processing_status,
      icon: 'sync',
      variant: 'info' as const,
      trend: t('knowledgeBase.currentProcessingState'),
      trendType: 'neutral' as const,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {metricCards.map((card, index) => (
        <MetricCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          variant={card.variant}
          trend={card.trend}
          trendType={card.trendType}
        />
      ))}
    </div>
  );
};
